import { render } from "./CertificationCard.vue?vue&type=template&id=586b6156&scoped=true&ts=true"
import script from "./CertificationCard.vue?vue&type=script&lang=ts"
export * from "./CertificationCard.vue?vue&type=script&lang=ts"

import "./CertificationCard.vue?vue&type=style&index=0&id=586b6156&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586b6156"]])

export default __exports__